import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Link } from 'react-router-dom';

// Components
import Input from '../form/Input';

// Misc
import * as v from '../../modules/validators';

import styles from '../../../stylesheets/public/components/Forms.module.postcss';

function RegisterForm({ handleSubmit, valid, submitting }) {
  return (
    <form
      className={styles.FlexForm}
      onSubmit={handleSubmit}
    >
      <div className='Fieldset'>
        <Field
          label='First name'
          name='first_name'
          component={Input}
          half
          type='text'
          required
          autoComplete='given-name'
          validate={[v.required]}
        />

        <Field
          label='Last name'
          name='last_name'
          component={Input}
          half
          type='text'
          required
          autoComplete='family-name'
          validate={[v.required]}
        />

        <Field
          label='Phone'
          name='phone'
          component={Input}
          type='tel'
          required
          autoComplete='tel'
          validate={[v.required]}
        />

        <Field
          label='Email'
          name='email'
          component={Input}
          type='email'
          required
          autoComplete='email'
          validate={[v.required, v.email]}
        />

        <Field
          label='Password'
          name='password'
          component={Input}
          type='password'
          required
          autoComplete='new-password'
          hint='Password must be at least 8 characters long.'
          validate={[v.required]}
        />

        <Field
          label='Confirm Password'
          name='password_confirmation'
          component={Input}
          type='password'
          required
          autoComplete='new-password'
          validate={[v.required]}
        />

        <div className='FormRow'>
          <div className='u-text-sm u-blockCenter u-textCenter u-mr3 u-ml3'>
            By clicking Create Account, you agree to the <Link to='/terms-and-conditions'>Terms of Use</Link> and <Link to='/privacy-policy'>Privacy Policy</Link>.
          </div>
          <button
            className='Button u-w100 u-mt1'
            type='submit'
            disabled={!valid || submitting}
          >
            <span className='u-w100 u-textCenter'>Create Account</span>
          </button>
        </div>
      </div>
    </form>
  );
}

RegisterForm.propTypes = {
  handleSubmit: PropTypes.func,
  valid: PropTypes.bool,
  submitting: PropTypes.bool
};

export default reduxForm({ form: 'register' })(RegisterForm);
